<template>
  <div class="sure-order-container">
    <!-- 回退 -->
    <div class="goBackIcon" @click="handleGoBack">
      <el-icon class="el-icon-back"></el-icon>
    </div>
    <!-- 主体 -->
    <div class="sure-order">
      <!-- 标题 -->
      <div class="sure-order-title">确认订单</div>
      <!-- 地址 -->
      <AddressList :choose-add-id="chooseAddId" @changAddId="changeAddId" ref="addressListRef" />
      <!-- 订单表单 -->
      <div class="sure-order-submit">
        <!-- 订单表单-顶部 -->
        <div class="submit-header" :style="{ background: getBgColor(storeType) }">
          <div class="header-title">确认商品信息</div>
          <div class="header-money">
            <div class="money-pick">
              <span>可用提货值</span>
              <span>{{ allDeliveyVal }}提货值</span>
            </div>
            <div class="money-amount">
              <span>可用金额</span>
              <span>￥{{ allBanlce }}</span>
            </div>
          </div>
        </div>
        <!-- 订单表单-信息 -->
        <div class="submit-body">
          <div class="good-des">
            <div class="des-info des-common">
              <div class="info-title title-common">商品描述</div>
              <div class="info-body">
                <div class="store-info">
                  <img v-if="storeType === 'U'" src="@/assets/images/pt-yxdp.png" alt="">
                  <img v-if="storeType === 'S'" src="@/assets/images/pt-zy.png" alt="">
                  <span>{{ storeName }}</span>
                </div>
                <div class="good-info">
                  <img :src="skuInfo?.skuImg" alt="">
                  <div class="info-text">
                    <div class="text-des">{{ goodDetail?.commodityName }}</div>
                    <div class="text-sku">{{ skuInfo?.skuName.replace(/\|/g, " ") }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="des-price des-common">
              <div class="price-title title-common">单价</div>
              <div class="price-body" v-if="payTypeInfo?.payType === 1"><span>￥</span>{{ retailPrice }}</div>
              <div class="price-body" v-if="payTypeInfo?.payType === 2">{{ retailPrice }}提货值</div>
            </div>
            <div class="des-num des-common">
              <div class="num-title title-common">数量</div>
              <div class="num-body"><span>X</span>{{ buyNum }}</div>
            </div>
            <div class="des-freight des-common" v-if="Number(freightFee) > 0">
              <div class="freight-title title-common">运费</div>
              <div class="freight-body"><span>￥</span>{{ freightFee }}</div>
            </div>
          </div>
          <div class="order-message">
            <div class="message-inner">
              <span>买家留言:</span>
              <el-input
                type="textarea"
                :rows="5"
                maxlength="50"
                v-model="message"
                placeholder="选填, 填写内容请和卖家确认"
              ></el-input>
            </div>
            <div class="order-price">
              <div class="price-total price-common">
                <div class="total-title title-common">商品总价 :</div>
                <div class="total-amount amount-common" v-if="payTypeInfo?.payType === 1">￥{{ totalRetailPrice }}</div>
                <div class="total-amount amount-common" v-else-if="payTypeInfo?.payType === 2">{{ totalRetailPrice }}提货值</div>
              </div>
              <div class="price-freight price-common" v-if="Number(freightFee) > 0">
                <div class="freight-title title-common">运费 :</div>
                <div class="freight-amount amount-common">￥{{ freightFee.toFixed(2) }}</div>
              </div>
              <div class="price-pay price-common">
                <div class="pay-title title-common">支付金额 :</div>
                <div class="pay-amount amount-common" v-if="payTypeInfo?.payType === 1">￥{{ (Number(totalRetailPrice) + Number(freightFee)).toFixed(2) }}</div>
                <div class="pay-amount amount-common" v-else-if="payTypeInfo?.payType === 2">{{ totalRetailPrice }}提货值<template v-if="Number(freightFee) > 0">+￥{{ freightFee.toFixed(2) }}</template></div>
              </div>
            </div>
          </div>
          
        </div>
        <!-- 订单表单-底部 -->
        <div class="submit-footer">
          <div class="footer-btn" @click="deliveryByHold">提交订单</div>
        </div>
      </div>
    </div>
    <payDialog ref="payPop" @surePay="surePay" />
  </div>
</template>

<script>
// import { mapState } from 'vuex'
import AddressList from '@/components/address/addressList.vue'
import payDialog from '@/components/base/payDialog/payDialog.vue'
export default {
  components: {
    AddressList,
    payDialog
  },
  data() {
    return {
      storeType: 'S', // P-普通店铺 U-优选店铺 S-自营店铺
      message: '', // 留言
      addressObj: {
        recipients: null,
        recipientsCellphone: null,
        city: null,
        address: null
      },
      applyObj: {},
      buyNum: 1,
      myAccount: {
        balance: null
      },
      isPwdPay: true,
      chooseAddId: null,

      retailPrice: null,
      skuInfo: null,
      buyNum: null,
      totalRetailPrice: null,
      goodDetail: null,
      payTypeInfo: null,
      freightFee: null, // 运费
      storeName: '',

      allBanlce: null, // 余额
      allDeliveyVal: null, // 提货值

      orderCode: null, // 订单code

      makeOrderInfo: null, // 创建订单以后的信息

      isRepeat: false, // 支付防重
    }
  },
  computed: {
    // ...mapState('pt', ['sureOrderInfo']),
    totalPrice() {
      if (this.buyNum) {
        return util.floatMul(this.buyNum, this.applyObj.price)
      }
      return 0
    },
  },
  mounted() {
    const sureOrderInfo = JSON.parse(sessionStorage.getItem('sureOrderInfo'))
    if (sessionStorage.getItem('sureOrderInfo')) {
      const {skuInfo, buyNum, totalRetailPrice, addressObj, storeName, retailPrice, ...goodDetail} = sureOrderInfo
      this.storeType = goodDetail.storeType
      this.skuInfo = skuInfo
      this.buyNum = buyNum
      this.totalRetailPrice = totalRetailPrice
      this.retailPrice = retailPrice
      this.goodDetail = goodDetail
      this.payTypeInfo = goodDetail.pays[0]
      this.addressObj = addressObj
      this.chooseAddId = this.addressObj.addressId // 选中商品页面的所选择的地址
      this.storeName = storeName
    }
    this.queryFreightFee()
    this.queryBalance() // 查询可用余额
    this.queryPick() // 查询提货值
    this.generateOrderCode() // 生成订单code
  },
  methods: {

    getBgColor(val) {
      switch (val) {
        case 'S':
          return 'linear-gradient( 0deg, #FFFFFF 0%, #FEECEB 100%)'
        case 'U':
          return 'linear-gradient( 0deg, #FFFFFF 0%, #FDF4DA 100%)'
        default:
          return '#fff'
      }
    },

    // 生成订单编码
    generateOrderCode() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_createShopOrderToken))
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.orderCode = value
          }
        } else {
          Toast(message)
          return false
        }
      })
    },

    // 创建订单
    makeOrder() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_makeOrder))
      apiObj.param = {
        addressId: this.addressObj.addressId, // 地址id
        bankId: window.g.Bank_Id, // 银行id
        commodityId: this.goodDetail.commodityId, // 商品id
        commoditySkuId: this.skuInfo.skuId, // 商品规格id
        message: this.message, // 留言
        orderCode: this.orderCode, // 订单编码
        payType: this.payTypeInfo.payType, // 支付方式
        quantity: this.buyNum // 购买数量
      }
      http.postFront(apiObj).then((res) => {
        const {code, message, value} = res.data
        if (Number(code) === 0) {
          if (JSON.stringify(value) !== '{}') {
            const { typeName, price } = this.getPaymentDisplayInfo()
            this.$refs.payPop.showSheet(price, typeName, value)
          }
        } else {
          this.$message(message)
        }
      })
    },

    // 查询可用余额
    queryBalance() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_findMyAssetMarket))
      http.postFront(apiObj).then(response => {
        const { code, message, value } = response.data
        if (code === '0') {
          if (value) {
            this.allBanlce = value?.availableFunds
          }
        } else {
          Toast(message)
        }
      })
    },

    // 查询可用提货值
    queryPick() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_findMyRewardMarket))
      apiObj.param = {
        rewardId: 472
      }
      http.getRes(apiObj).then((response) => {
        const { code, message, value } = response.data
        if (code === '0') {
          this.allDeliveyVal = value?.balance
        } else {
          Toast(message)
        }
      })
    },

    // 查询运费
    queryFreightFee() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_computeOrderShippingFee))
      apiObj.param = {
        addressId: this.addressObj.addressId, // 地址id
        commodityId: this.goodDetail.commodityId, // 商品id
        commoditySkuId: this.skuInfo.skuId, // 商品规格id
        quantity: this.buyNum, // 购买数量
      }
      http.postFrontMall(apiObj).then((res) => {
        const {code, message, value} = res.data
        if (Number(code) === 0) {
          this.freightFee = value.shippingFee
        } else {
          this.$message(message)
        }
      })
    },

    // 获取支付弹窗显示信息
    getPaymentDisplayInfo() {
      const payType = this.payTypeInfo.payType
      const symbolName = this.payTypeInfo.symbolNameCh
      const hasShippingFee = this.freightFee > 0
      const formattedShippingFee = this.freightFee
      const formattedTotalAmount = Number(payType) === 1 ? (Number(this.totalRetailPrice) + Number(this.freightFee)).toFixed(2) : this.totalRetailPrice

      // 提货值支付（payType === 2）
      if (this.payTypeInfo.payType === 2) {
        // const typeName = `支付${symbolName}${hasShippingFee ? '+运费' : ''}`
        const typeName = `支付金额`
        const price = `${formattedTotalAmount}${symbolName}${hasShippingFee ? ` +￥${formattedShippingFee.toFixed(2)}` : ''}`
        return { typeName, price }
      }

      // 余额支付（payType === 1）
      return {
        typeName: '支付金额',
        price: `￥${formattedTotalAmount}`
      }
    },

    // 提交订单
    deliveryByHold() {
      if (Number(this.buyNum <= 0)) {
        return this.$message('数量需大于0')
      }
      if (Number(this.goodDetail.reserve) < Number(this.buyNum)) {
        return this.$message('剩余库存不足')
      }
      if (Number(this.allBanlce) < Number(this.totalRetailPrice) && Number(this.payTypeInfo.payType) === 1) {
        return this.$message('可用资金不足')
      }
      if (Number(this.allDeliveyVal) < Number(this.totalRetailPrice) && Number(this.payTypeInfo.payType) === 2) {
        return this.$message('可用提货值不足')
      } 
      this.makeOrder()
    },
    // 选择地址
    changeAddId(id) {
      this.addressObj.addressId = id
      // 查询新地址运费
      this.queryFreightFee()
    },
    // 确定支付
    surePay(val) {
      this.payOrder(val)
    },
    // 支付订单
    payOrder(pwd) {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_payOrder))
      apiObj.param = {
        activityId: null, // 普通商品不需要
        addressId: this.addressObj.addressId, // 地址id
        bankId: window.g.BANK_ID,
        commodityId: this.goodDetail.commodityId,
        commoditySkuId: this.skuInfo.skuId,
        message: this.message,
        orderCode: this.orderCode,
        password: util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + pwd),
        payType: this.payTypeInfo.payType, // 支付方式
        quantity: this.buyNum, // 购买数量
      }
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        return
      }
      http.postFrontMall(apiObj).then((response) => {
        const { code, message, value } = response.data
        this.isRepeat = false
        if (Number(code) === 0) {
          this.resultPrice = value.totalPrice
          this.$refs.payPop.closeSheet()
          this.$message('支付成功！')
          setTimeout(() => {
            this.$router.replace(`/orderManagement/12`)
          }, 1000)
        } else {
          this.$refs.payPop.closeSheet()
          this.$refs.payPop.currentStatus = false
          this.$message(message)
        }
      }).catch(() => {
        this.isRepeat = false
      })
    },
    // 返回上一页
    handleGoBack() {
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped lang="scss">
  .sure-order-container {
    min-height: calc(100vh - 40px);
    background: #f4f4f4;
    position: relative;
    width: 100%;
    color: #333333;
    font-family: PingFang TC-Medium;
    // 回退
    .goBackIcon {
      cursor: pointer;
      height: 40px;
      width: 40px;
      position: absolute;
      top: 30px;
      left: 50px;
      background: #666666;
      color: #ffffff;
      font-size: 30px;
      line-height: 38px;
      text-align: center;
      border-radius: 2px;
    }
    // 主体
    .sure-order {
      // 标题
      .sure-order-title {
        width: 1200px;
        margin: 0 auto;
        height: 55px;
        line-height: 55px;
        font-size: 16px;
        font-weight: 500;
        text-align: left;
      }
      // 订单表单
      .sure-order-submit {
        width: 1200px;
        height: 420px;
        margin: 20px auto;
        font-size: 14px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // 订单表单-顶部
        .submit-header {
          width: 100%;
          height: 40px;
          padding: 0 10px;
          box-sizing: border-box;
          // background: linear-gradient(to bottom, #FFE6E6, #FFFBFB);
          display: flex;
          align-items: center;
          justify-content: space-between;
          .header-title {
            font-weight: 500;
          }
          .header-money {
            display: flex;
            align-items: center;
            gap: 20px;
            .money-pick {
              span {
                &:nth-child(2) {
                  margin-left: 10px;
                }
              }
            }
            .money-amount {
              span {
                &:nth-child(2) {
                  margin-left: 10px;
                }
              }
            }
          }
        }
        // 订单表单-信息
        .submit-body {
          flex: 1;
          border-bottom: 1px solid #eeeeee;
          width: 100%;
          box-sizing: border-box;
          padding: 10px 0 0 10px;
          display: flex;
          flex-direction: column;
          .good-des {
            display: flex;
            align-items: flex-start;
            .title-common {
              font-size: 14px;
              color: #666666;
              font-weight: 400;
            }
            .des-common {
              &:nth-child(n+2) {
                width: 125px;
                height: 104px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              }
            }
            .des-info {
              .info-title {}
              .info-body {
                margin-top: 19px;
                .store-info {
                  display: flex;
                  align-items: center;
                  gap: 10px;
                  img {
                    height: 16px;
                  }
                  span {
                    font-size: 16px;
                  }
                }
                .good-info {
                  margin-top: 11px;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  img {
                    width: 36px;
                    height: 36px;
                  }
                  .info-text {
                    font-size: 12px;
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                    .text-des {
                      color: #333333;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      width: 300px;
                    }
                    .text-sku {
                      color: #999999;
                    }
                  }
                }
              }
            }
            .des-num {
              .num-body {
                span {
                  font-size: 12px;
                }
              }
            }
            .des-freight {
              margin-right: 60px;
              .freight-body {
                span {
                  font-size: 10px;
                }
              }
            }
            .des-price {
              margin-left: auto;
              .price-body {
                span {
                  font-size: 10px;
                }
              }
            }
          }
          .order-message {
            flex: 1;
            display: flex;
            .message-inner {
              margin-top: 10px;
              width: 50%;
              display: flex;
              align-items: flex-start;
              span {
                white-space: nowrap;
                font-size: 14px;
                color: #333333;
              }
              /deep/.el-textarea {
                font-size: 14px;
                color: #333333;
                height: 20px;
                width: 40%;
                .el-textarea__inner {
                  border: none;
                  border-radius: 0;
                  padding-top: 1px;
                  padding-bottom: 0;
                  min-height: 20px !important;
                  resize: none;
                  &::-webkit-scrollbar {
                    width: 0 !important;
                    height: 0 !important;
                  }
                  &::placeholder {
                    color: #999999;
                    font-size: 14px;
                  }
                  &::-webkit-input-placeholder {
                    color: #999999;
                    font-size: 14px;
                  }
                  &::-moz-placeholder {
                    color: #999999;
                    font-size: 14px;
                  }
                }
              }
            }
            .order-price {
              margin: 40px 50px 0 auto;
              .price-common {
                display: flex;
                justify-content: space-between;
                gap: 27px;
                .title-common {
                  width: 70px;
                  text-align: right;
                  color: #333333;
                  font-size: 14px;
                }
                .amount-common {
                  text-align: right;
                }
              }
              .total-title {

              }
              .price-freight {
                margin-top: 10px;
              }
              .price-pay {
                margin-top: 20px;
                display: flex;
                align-items: center;
                .pay-amount {
                  font-size: 18px;
                  font-weight: 500;
                  color: #EB6643;
                  white-space: nowrap;
                  flex: 1;
                }
              }
            }
          }
        }
        // 订单表单-底部
        .submit-footer {
          height: 102px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .footer-btn {
            background: linear-gradient(to right, #EA553C, #EE8C54);
            width: 233px;
            height: 54px;
            margin-right: 30px;
            border-radius: 54px;
            line-height: 54px;
            text-align: center;
            font-size: 20px;
            color: #ffffff;
            font-weight: 400;
            cursor: pointer;
            user-select: none;
            &:hover {
              filter: brightness(1.05)
            }
            &:active {
              filter: brightness(0.95)
            }
          }
        }
      }
    }
  }
</style>